<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="filteredAdmins"
        :items-per-page="10"
        class="elevation-0 custom-data-table"
        :no-data-text="noDataText"
        :height="tableHeight"
        fixed-header
        :loading="tableLoading"
        density="compact"
      >
        <template v-slot:top>
          <div class="d-flex justify-space-between align-center pa-4">
            <span class="text-h5">Administrators</span>
            <div class="d-flex align-center">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                variant="outlined"
                density="compact"
                style="width: 350px; margin-right: 16px"
              ></v-text-field>
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="openCreateDialog"
              >
                Add Admin
              </v-btn>
            </div>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            size="small"
            variant="text"
            color="error"
            @click="openDeleteDialog(item)"
            v-if="
              item.user_email_id !== this.$store.state.user?.email &&
              item.user_email_id !== 'bhambri.mukul@gmail.com'
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create Admin Dialog -->
    <CreateAdminDialog
      v-model="showCreateDialog"
      @created="handleAdminCreated"
    />

    <!-- Delete Admin Dialog -->
    <DeleteAdminDialog
      v-model="showDeleteDialog"
      :admin-email="selectedAdminEmail"
      @deleted="handleAdminDeleted"
    />
  </div>
</template>

<script>
import CreateAdminDialog from "../../components/Administration/Dailogs/CreateAdminDialog.vue";
import DeleteAdminDialog from "../../components/Administration/Dailogs/DeleteAdminDialog.vue";
import GetAdmins from "@/mixins/Administration/GetAdmins";

export default {
  name: "AdministrationView",
  mixins: [GetAdmins],
  components: {
    CreateAdminDialog,
    DeleteAdminDialog,
  },
  data() {
    return {
      showCreateDialog: false,
      showDeleteDialog: false,
      tableLoading: false,
      selectedAdminEmail: "",
      selectedAdminIndex: -1,
      admins: [],
      search: "",
      windowHeight: window.innerHeight,
      headers: [
        { title: "Email ID", key: "user_email_id", sortable: true },
        { title: "Actions", key: "actions", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    noDataText() {
      return "No administrators found. Click 'Add Admin' to add one.";
    },
    tableHeight() {
      return this.windowHeight - 200;
    },
    filteredAdmins() {
      if (!this.search) {
        return this.admins;
      }

      const searchTerm = this.search.toLowerCase().trim();
      return this.admins.filter((admin) => {
        return (
          admin.user_email_id &&
          admin.user_email_id.toLowerCase().includes(searchTerm)
        );
      });
    },
  },
  async mounted() {
    this.updateWindowHeight();
    window.addEventListener("resize", this.updateWindowHeight);
    this.tableLoading = true;
    try {
      await this.fetchAdmins();
      this.admins = this.adminsList;
    } catch (error) {
      console.error("Error loading admins:", error);
    } finally {
      this.tableLoading = false;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowHeight);
  },
  methods: {
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },

    openCreateDialog() {
      this.showCreateDialog = true;
    },
    openDeleteDialog(admin) {
      this.selectedAdminEmail = admin.user_email_id;
      // Find the actual index in the original admins array
      this.selectedAdminIndex = this.admins.findIndex(
        (a) => a.user_email_id === admin.user_email_id
      );
      this.showDeleteDialog = true;
    },
    async handleAdminCreated() {
      // Refetch the admin list from API
      this.tableLoading = true;
      try {
        await this.fetchAdmins();
        this.admins = this.adminsList;
      } catch (error) {
        console.error("Error loading admins:", error);
      } finally {
        this.tableLoading = false;
      }
    },
    async handleAdminDeleted() {
      // Refetch the admin list from API
      this.tableLoading = true;
      try {
        await this.fetchAdmins();
        this.admins = this.adminsList;
      } catch (error) {
        console.error("Error loading admins:", error);
      } finally {
        this.tableLoading = false;
      }
      this.selectedAdminIndex = -1;
      this.selectedAdminEmail = "";
    },
  },
};
</script>


